/* ==============================================================================================
 * SWITCHER
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var Switcher;

	Switcher = function (triggerElement, options) {
		Sushi.Plugins.BasePlugin.call(this, triggerElement, options);

		this.init();
	};

	Switcher.displayName = "Switcher";

	Switcher.DEFAULTS = {};

	Switcher.prototype = Object.create(Sushi.Plugins.BasePlugin.prototype);

	Switcher.state = Object.create({
		checked: false,
	});

	var proto = Switcher.prototype;
	var state = Switcher.state;

	proto.constructor = Switcher;

	proto.init = function () {
		var options = this.triggerElement.querySelector(".c-switcher__options");

		options.addEventListener("click", this.switch.bind(this));

		this.update();
	};

	proto.switch = function () {
		state.checked = !state.checked;

		this.update();
		Sushi.Events(this.triggerElement).trigger("Switcher.switch");
	};

	proto.update = function () {
		if (state.checked === true) {
			this.triggerElement.classList.add("c-switcher--checked");
		}

		else {
			this.triggerElement.classList.remove("c-switcher--checked");
		}
	};

	Sushi.Plugins.Switcher = Switcher;

})(Sushi || (Sushi = {}));
